import { CircularProgress, Grid } from '@mui/material';
import { deleteObjectApi, postSaveObjectApi } from 'api/general';
import { getUserByRoleIdAndInstApi } from 'api/user';
import UserParticipantDataTable from 'app/components/DataTable/meetingUser/UserParticipantDataTable';
import { swal_error } from 'app/utils/appHelpers';
import { MEETING_USER } from 'app/utils/constants/customConstant';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentMeetingParticipants, setCurrentMeetingUsers } from 'stores/meeting';
import MeetingMemberDataTable from '../DataTable/meetingUser/MeetingMemberDataTable';


function MeetingUserTab({ componentType }) {
    const { currentMeeting, currentMeetingUsers, currentMeetingParticipants } = useSelector((state) => ({
        currentMeeting: state.meeting.currentMeeting,
        currentMeetingUsers: state.meeting.currentMeetingUsers,
        currentMeetingParticipants: state.meeting.currentMeetingParticipants
    }));
    const [sortingRequired, setSortingRequired] = useState(false);
    const [selectedMemberRole, setSelectedMemberRole] = useState({});
    const [selectedActing, setSelectedActing] = useState({});
    const [loading, setLoading] = useState(true);
    const [userList, setUserList] = useState([]); // uye rolüne sahip olanlar
    const [updateReduxFlag, setUpdateReduxFlag] = useState(true);
    const dispatch = useDispatch();

    function updateRedux(list) {
        if (componentType === "user") {
            dispatch(setCurrentMeetingUsers(list));
        } else if (componentType === "participant") {
            dispatch(setCurrentMeetingParticipants(list));
        }
    }

    useEffect(() => {

        const getAPI = async () => {
            try {
                setLoading(true)

                let data = [];
                if (componentType === "user") {
                    data = await getUserByRoleIdAndInstApi(100, "all");
                    data = data.data;
                    setUserList(data)

                } else {
                    data = await getUserByRoleIdAndInstApi(104, "all");
                    data = data.data;
                    setUserList(data)

                }


            } catch (error) {
                console.error('Hata:', error);
            } finally {
                setLoading(false);

            }

        };
        getAPI();

    }, []);



    const handleDeleteMeetingUser = async (meetingUserObj) => {
        const result = await deleteObjectApi(MEETING_USER, meetingUserObj.id);
        let filteredList = [];
        if (result.status) {
            if (componentType === "user") {
                filteredList = currentMeetingUsers.filter(x =>
                    !(x.id === meetingUserObj.id)
                );
            } else {
                filteredList = currentMeetingParticipants.filter(x =>
                    !(x.id === meetingUserObj.id)
                );
            }

            // Local state güncelle
            updateRedux([...filteredList])
            setUpdateReduxFlag(true);
            if (filteredList.length > 0) {
                setSortingRequired(true);
            }

        }
    }


    let meetingUser = { acting: 'Asaleten' }

    const addMember = async (user) => {
        try {
            meetingUser.userId = user.id;
            meetingUser.meetingId = currentMeeting.id
            if (user.inst === "AKMB") {
                meetingUser.inst = "AKM"
            }

            let reduxData = [];
            if (componentType === "user") {
                meetingUser.type = 1;
                meetingUser.inst = currentMeeting.inst === "YK" ? "Yönetim Kurulu Üyesi" : currentMeeting.inst;
                meetingUser.memberRole = "Üye";
                reduxData = currentMeetingUsers;
            } else {
                meetingUser.type = 2;
                meetingUser.memberRole = "Katılımcı";
                meetingUser.inst = '';
                reduxData = currentMeetingParticipants;
            }

            const result = await postSaveObjectApi(MEETING_USER, meetingUser)
            if (result.status) {
                meetingUser.user = user
                meetingUser.id = result.data.insertId

                // Local state güncelle
                updateRedux([meetingUser, ...reduxData])
                setUpdateReduxFlag(true);
                setSortingRequired(true);
            } else {
                swal_error("Kullanıcı eklenemedi", 1500);
            }
        } catch (error) {
            swal_error("Kullanıcı eklenemedi", 1500);
        }
    };


    const columnData = [
        { id: 'index', align: 'center', disablePadding: false, label: 'Sıra' },


        ...(componentType !== undefined && componentType !== "user" ? [
            { id: 'title', align: 'center', disablePadding: true, label: 'Katılımcı' },
            { id: 'unvan', align: 'center', disablePadding: true, label: 'Unvan' },
        ] : []),


        ...(componentType !== undefined && componentType === "user" ? [
            { id: 'title', align: 'center', disablePadding: true, label: 'Üye' },
            { id: 'inst', align: 'center', disablePadding: true, label: 'Kurum' },
            { id: 'rol', align: 'center', disablePadding: false, label: 'Rol' },
            { id: 'atama', align: 'center', disablePadding: false, label: 'Atama' },
        ] : []),

        { id: 'sil', align: 'center', disablePadding: false, label: 'Sil' },
    ];
    return (

        <div>

            <Grid container >
                <Grid container spacing={3.75}>
                    {loading ? <Grid container justifyContent="center" alignItems="center" item xs={6} sm={12} lg={12} >
                        <CircularProgress size={50} />
                    </Grid>
                        :

                        <>
                            <Grid item xs={6} sm={6} lg={6} >
                                <UserParticipantDataTable addMember={addMember} componentType={componentType} mainData={userList} column={columnData} pageTitle="Üye Rolü Bulunanlar" />
                            </Grid>

                            <Grid item xs={6} sm={6} lg={6} >
                                <Grid container spacing={3.75}>
                                    <Grid item xs={12} sm={12} lg={12}>

                                        <MeetingMemberDataTable
                                            column={columnData}
                                            handleDeleteUser={(user) => handleDeleteMeetingUser(user)}
                                            componentType={componentType}
                                            selectedMemberRole={selectedMemberRole}
                                            setSelectedMemberRole={setSelectedMemberRole}
                                            selectedActing={selectedActing}
                                            setSelectedActing={setSelectedActing}
                                            updateRedux={updateRedux}
                                            updateReduxFlag={updateReduxFlag}
                                            setUpdateReduxFlag={setUpdateReduxFlag}
                                            sortingRequired={sortingRequired}
                                            setSortingRequired={setSortingRequired}
                                        />
                                    </Grid>

                                </Grid>
                            </Grid>
                        </>
                    }

                </Grid>
            </Grid>

        </div>

    )
}
const style = document.createElement('style');
style.innerHTML = `
    .swal-container-custom {
        z-index: 10000 !important;
    }
`;
document.head.appendChild(style);
export default MeetingUserTab
